/* File : src/pages/GuestPages/HomePage.js */
import React, { useEffect } from 'react'; // N'oubliez pas d'importer useEffect
import AgeVerification from '../../components/guest/AgeVerification';
import './GuestPages.css';

/**
 * Page d'accueil avec la vérification d'âge
 */
const HomePage = () => {
  // Ajout du useEffect à l'intérieur du composant
  useEffect(() => {
    // Récupérer les paramètres de l'URL
    const params = new URLSearchParams(window.location.search);
    const source = params.get('source');
    const invitation = params.get('invitation');
    const referrer = params.get('referrer');
    
    // Sauvegarder les paramètres dans localStorage s'ils existent
    if (source) localStorage.setItem('acquisition_source', source);
    if (invitation) localStorage.setItem('invitation_type', invitation);
    if (referrer) localStorage.setItem('referrer', referrer);
    
    // Optionnel: Nettoyer l'URL (si vous préférez une URL propre sans paramètres)
    if (source || invitation || referrer) {
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }, []);

  return (
    <div className="guest-page">
      <AgeVerification />
    </div>
  );
};

export default HomePage;